import React, { useState } from 'react';
import BillingLocations from '../multiLocation/BillingLocations';
import SettingsPageLayout from './SettingsPageLayout';
import { connect } from 'react-redux';
import Invoices from './Invoices';
import CreditPurchases from './CreditPurchases';
import { methodBrand, isCardExpired, brandIcon, useBillingCards, CardDetailPanel } from './billingCards';
import { PRICING_V2_VISIBLE } from '../../config/featureFlags';
import { isOwnerHere, isSelfEmployedMe, useAccess } from '../permissions/access';
import PlanBillingPage from '../pricing/PlanBillingPage';
import './SettingsModern.css';

/* ── Component ── */

function Billing(props) {
    const cards = useBillingCards();
    const { cardList, defaultPayment, setSelectedCard, addCard } = cards;
    const [showAllCards, setShowAllCards] = useState(false);
    const [historyTab, setHistoryTab] = useState('invoices');
    const CARD_DISPLAY_LIMIT = 4;
    /* ── Render ── */

    return (
        <SettingsPageLayout activeTab="billing" {...props}>

            {/* Multi-location: one line per location (renders nothing for single-site salons) */}
            <BillingLocations />


            {/* ── Payment Methods ── */}
            <div className="settings-card">
                <div className="settings-card-header">
                    <h2>Payment Methods</h2>
                    <p>Manage the cards used for Beu fees and subscriptions.</p>
                </div>

                {cardList.length > 0 ? (
                    <div className="bi-card-list">
                        {(showAllCards ? cardList : cardList.slice(0, CARD_DISPLAY_LIMIT)).map((card) => {
                            const isDefault = defaultPayment === card.id;
                            const expired = isCardExpired(card);
                            return (
                                <div
                                    key={card.id}
                                    className={`bi-card-row${isDefault ? ' bi-card-row--default' : ''}`}
                                    onClick={() => setSelectedCard(card)}
                                >
                                    <div className="bi-card-icon">
                                        {brandIcon(card?.card?.brand)}
                                    </div>
                                    {/* Stripe returns EVERY payment-method type (the checkouts
                                        save Link methods too) — a Link entry has no .card and
                                        rendered as "undefined ending in undefined". */}
                                    <div className="bi-card-info">
                                        <span className="bi-card-brand">
                                            {methodBrand(card)}
                                        </span>
                                        <span className="bi-card-number">
                                            {card?.card?.last4
                                                ? `ending in ${card.card.last4}`
                                                : (card?.link?.email || 'saved payment method')}
                                        </span>
                                    </div>
                                    <div className="bi-card-meta">
                                        {expired && <span className="bi-badge bi-badge--expired">Expired</span>}
                                        {isDefault && <span className="bi-badge bi-badge--default">Default</span>}
                                    </div>
                                    <span className="bi-card-arrow">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                                    </span>
                                </div>
                            );
                        })}
                        {!showAllCards && cardList.length > CARD_DISPLAY_LIMIT && (
                            <button className="bi-show-more" onClick={() => setShowAllCards(true)}>
                                Show all {cardList.length} cards
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="bi-empty">
                        <div className="bi-empty-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                        </div>
                        <p>No payment methods added yet</p>
                        <span>Add a card to get started with Beu services</span>
                    </div>
                )}

                <div className="bi-add-card-wrap">
                    <button className="bi-add-card-btn" onClick={addCard}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                        Add card
                    </button>
                </div>
            </div>

            {/* ── Billing history ──
                Two different instruments, so they get their own tabs rather than
                one merged list: invoices are the monthly platform bill, credit
                purchases are one-off card charges whenever credits are bought. */}
            <div className="bi-history-tabs">
                <button
                    type="button"
                    className={`bi-history-tab${historyTab === 'invoices' ? ' bi-history-tab--active' : ''}`}
                    onClick={() => setHistoryTab('invoices')}
                >
                    Invoices
                </button>
                <button
                    type="button"
                    className={`bi-history-tab${historyTab === 'credits' ? ' bi-history-tab--active' : ''}`}
                    onClick={() => setHistoryTab('credits')}
                >
                    Top-ups
                </button>
            </div>
            {historyTab === 'invoices' ? <Invoices /> : <CreditPurchases />}

            {/* ── Card Detail Panel ── */}
            {/* ── Card Detail Panel ── */}
            <CardDetailPanel cards={cards} />

        </SettingsPageLayout>
    );
}

function mapStateToProps(state) {
    return { ...state };
}

const ConnectedBilling = connect(mapStateToProps)(Billing);

/**
 * Settings › Billing. With the October pricing on (PRICING_V2_VISIBLE) the
 * owner (the salon's plan) and a self-employed stylist (their own, never a
 * salon figure) get the one "Plan & billing" page; with the flag off, this
 * page exactly as before.
 */
export default function BillingRoute(props) {
    useAccess();
    if (PRICING_V2_VISIBLE && (isOwnerHere() || isSelfEmployedMe())) return <PlanBillingPage {...props} />;
    return <ConnectedBilling {...props} />;
}
